import { useQuery } from "react-query";
import { getIntercomUserJwtKey } from "./getIntercomUserJwtKey";
import axios from "src/services/network/axios";

type IntercomUserJwtResponseType = {
  token: string;
};

const getUserJwt = async () => {
  const response = await axios.get(`/other/messengerToken`);

  return response?.data || {};
};

const useIntercomUserJwtQuery = (userId: string | null) => {
  const queryKey = getIntercomUserJwtKey(userId);

  const query = useQuery<IntercomUserJwtResponseType>({
    queryKey,
    queryFn: getUserJwt,
    staleTime: 15 * 60 * 1000,
    enabled: !!userId,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return query;
};

export default useIntercomUserJwtQuery;
